import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { switchMap, map, share, catchError, withLatestFrom, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { DefaultResponse } from '@toro/common/shared/models/form/DefaultResponse';
import { BackendService as NewBackendService} from '@toro/common/shared/services/new-http/backend.service';
import { TraderActions } from './trader.actions';

@Injectable()
export class TraderEffects {

    /**
     * Busca Perfil Trader do Usuário.
     * @method getTrader
     */
     @Effect()
     public getProfileTrader$ = this.actions$
         .pipe(
             ofType(TraderActions.getProfileTrader),
             withLatestFrom(this.store$.select((s) => s.authentication)),
             filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
             switchMap((action, auth) => {
                return this.newBackendService.api.get<DefaultResponse>('/trader/real')
                    .pipe(
                        map((result) => {
                            if (result) {
                                return { type: TraderActions.getProfileTraderSuccess, payload: result };
                            }
                        }),
                        catchError((error) =>
                            of({ type: TraderActions.getProfileTraderError, payload: error }),
                        ));
             }),
             share());

    constructor(
        private actions$: Actions<TraderActions>,
        private store$: Store<any>,
        private newBackendService: NewBackendService
    ) { }
}
